import { useUserStore } from '@/stores/user'
import { t } from '@/locales'
import { getRiskStatus } from '@/api/user'
import { showBannedDialog, closeBannedDialog } from '@/components/BannedDialog'

// 封禁弹窗是否已显示（避免重复弹窗）
let isBannedDialogShowing = false

/**
 * 处理用户封禁
 * 统一处理 403 状态码、code === 10001 和 IM 封禁推送的封禁逻辑
 */
export async function handleUserBanned() {
  // 如果弹窗已显示，避免重复弹出
  if (isBannedDialogShowing) {
    return
  }

  isBannedDialogShowing = true
  let riskStatus = null;
  try {
    // 获取封禁状态信息
    riskStatus = await getRiskStatus()
  } catch (error) {
    console.error('Failed to get risk status', error)
  }

  // 显示封禁提示弹窗
  showBannedDialog({
    title: riskStatus.title || t('common.suspendedPopup.title'),
    tips: riskStatus.body || t('common.suspendedPopup.message'),
    extra: riskStatus.extra,
    unbanTime: riskStatus.unbanned_time,
    buttonContent: riskStatus.button_content || t('common.confirm'),
    onConfirm: () => {
      // 用户点击确认后，退出登录
      const userStore = useUserStore()
      userStore.clearLoginState()
      closeBannedDialog()
    },
    onClosed: () => {
      // 弹窗关闭后重置标志
      isBannedDialogShowing = false
    },
  })
}
